// The edition picked on a landing page (agency / in-house), kept in this browser so a Google/Microsoft sign-up
// (which skips our form) can carry it through login. Mirrors referralLink.js.
const EDITION_KEY = "scoutm8:edition";
const MAX_AGE_MS = 7 * 86400000;

export function storeEdition(edition) {
  try {
    if (edition) localStorage.setItem(EDITION_KEY, JSON.stringify({ edition, at: Date.now() }));
    else localStorage.removeItem(EDITION_KEY);
  } catch {}
}

// The saved edition, or "" when none or over a week old.
export function readEdition() {
  try {
    const ref = JSON.parse(localStorage.getItem(EDITION_KEY) || "null");
    return ref?.edition && Date.now() - (ref.at || 0) < MAX_AGE_MS ? String(ref.edition) : "";
  } catch {
    return "";
  }
}
